import { Action } from 'redux'
import { CalendarActions } from '../../../reducers/bookingCalendar/actionNames'

const calendarIsReady = (): ICalendarIsReady => ({
  type: CalendarActions.IsReady,
})

const calendarIsLoading = (): ICalendarIsLoading => ({
  type: CalendarActions.IsLoading,
})

export default calendarIsReady
export { calendarIsLoading }

export type ICalendarIsReady = Action<CalendarActions.IsReady>
export type ICalendarIsLoading = Action<CalendarActions.IsLoading>
